export default {
  "content": "<g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M8.5 5.455v3.272l4.25-4.363L8.5 0v3.273C3.804 3.273 0 7.178 0 12c0 1.713.489 3.305 1.317 4.647l1.552-1.592A6.54 6.54 0 012.125 12c0-3.61 2.858-6.545 6.375-6.545zm7.183 1.898L14.13 8.945c.468.917.744 1.953.744 3.055 0 3.61-2.858 6.545-6.375 6.545v-3.272l-4.25 4.363L8.5 24v-3.273c4.696 0 8.5-3.905 8.5-8.727a8.821 8.821 0 00-1.317-4.647z\" fill=\"#000\" fill-rule=\"nonzero\"/><path d=\"M-3 0h24v24H-3z\"/></g>",
  "attrs": {
    "width": "17",
    "height": "24",
    "viewBox": "0 0 17 24",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};